<template>
  <div class="is-border is-margin-top-xsmall">
    <div v-if="reminder && !isLoadingReminders && (isAdmin || isSectorManager)" class="columns is-gapless is-border-top has-bg-white is-border-left is-border-right">
      <div class="column is-self-centered is-padding-left is-padding-right has-text-right">
        <div class="has-text-danger is-size-6">Rappel : Le <b> {{reminder.date | dateReminder}} </b> - Création : <b v-if="'is_automatic' in reminder && reminder.is_automatic">Automatique</b><b v-else>Manuel</b> -
          Destinataire : <b>{{reminder.user_name}}</b>
          <a class="has-text-danger is-underline is-italic" @click.prevent.stop="openReminder">(Modifier)</a>
        </div>
      </div>
      <div class="column is-narrow has-bg-danger is-flex is-padding-small">
        <span class="icon has-text-white is-self-centered"><i class="fas fa-alarm-clock"></i></span>
      </div>
    </div>
    <div class="columns is-gapless is-border-top has-bg-white is-border-left is-border-right"
         :class="{'is-min-height-50 is-flex' : index < 1}">
      <div class="column is-self-centered is-padding-right is-padding-left">
        <div class="is-self-centered"><span class="is-uppercase title is-6">Prêt N° {{index + 1}}</span></div>
      </div>
      <div v-if='index >= 1' class="column is-narrow has-bg-white is-border-left is-flex is-padding-small">
        <a @click="remove()" data-tooltip="Supprimer la ligne"
           class="page-header-btn is-small is-square tooltip is-tooltip-top">
					<span class="icon has-text-grey is-size-4">
						<i class="fal fa-trash-alt"></i>
					</span>
        </a>
      </div>
    </div>
    <div class="columns is-12 is-gapless is-padding-left-small is-vcentered is-min-height-50"
         :class="!loan.has_mandat_courtage ? 'is-border-top has-bg-light is-border-left is-border-right ' : 'has-bg-dark'">
      <div class="column is-self-centered is-padding-right">
        <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
          <div>
            <input :id="index + '-has_mandat_courtage'" v-model="loan.has_mandat_courtage" @input="commitAdv()"
                   :name="index + '-has_mandat_courtage'" class="switch is-success is-rounded" type="checkbox">
            <label :for="index + '-has_mandat_courtage'" style="font-size: 12.5px"
                   :class="!loan.has_mandat_courtage ? '' : 'has-text-white'" class="is-uppercase">MANDAT DE COURTAGE</label>
          </div>
        </div>
      </div>
      <template v-if="loan.has_mandat_courtage">
        <div v-if="!loan.document || !loan.document.path"
             class="column is-narrow has-bg-white is-border is-flex is-padding-small">
          <div class="file">
            <label class="w100 tooltip is-tooltip-top has-cursor-pointer" data-tooltip="Lier document">
              <input class="file-input" type="file" accept='image/png, image/jpeg, .pdf' @change="processFile($event)"
                    name="resume">
              <span class="page-header-btn is-small is-grey-dark is-fullwidth">
                <span v-if="!uploading" class="icon has-text-grey is-self-centered"><i class="far fa-link"></i></span>
                <span v-else class="icon has-text-grey is-self-centered"><i
                  class="fas fa-spinner fa-spin is-margin-xsmall"></i></span>
              </span>
            </label>
          </div>
        </div>
        <template v-else>
          <div v-if="loan.document.display || isAdmin || isSectorManager" class="column is-narrow has-bg-white is-border is-flex is-padding-small">
            <a @click="download()" class="icon has-text-grey is-self-centered tooltip is-tooltip-top" data-tooltip="Télécharger"><i class="fal fa-download"></i></a>
          </div>
          <div v-if="isAdmin || isSectorManager" class="column is-narrow has-bg-white is-border is-flex is-padding-small">
            <a @click="unlink()" class="icon has-text-grey is-self-centered tooltip is-tooltip-top" data-tooltip="Supprimer document lié"><i class="fal fa-unlink"></i></a>
          </div>
        </template>
      </template>
    </div>
    <div class="columns is-multiline is-border-top has-bg-grey3 is-padding-bottom">
      <div class="column is-gapless is-paddingless is-12 columns is-multiline">
        <div class="column is-6 is-padding-left is-padding-right is-padding-top">
          <r-label :label="'Organisme bancaire'" :redCheck='true' :value="loan.bank_name"></r-label>
          <v-input id="initial_bank_name" name="initial_bank_name" @input="val => update(val)"
                   :model="loan.bank_name"
                   data-vv-as="Organisme bancaire"
                   v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val">
          </v-input>
        </div>
      </div>
    </div>
    <div class="columns has-bg-grey3 is-multiline is-padding-bottom">
      <div class="column is-gapless is-paddingless is-12 columns is-multiline">
        <div class="column is-4 is-padding-left is-padding-right is-padding-top">
          <r-label :label="'DATE DE DÉPÔT DU DOSSIER'" :value="loan.depot_de_dossier" :redCheck="true"></r-label>
          <div class="field has-addons">
            <div class="control">
              <a class="button is-static is-border is-min-width-0 is-square">
                <span class="icon"><i class="fas fa-calendar-alt"></i></span>
              </a>
            </div>
            <div class="control is-expanded has-icons-right">
              <flat-pickr :config="configDate" type="date" @input="commitAdv()"
                class="input is-padding-left-xxsmall is-padding-right-xxsmall"
                v-model="loan.depot_de_dossier"></flat-pickr>
            </div>
            <div class="control">
              <a class="button is-grey is-inverted is-border is-min-width-0 is-square"
                 @click="deleteDate(loan, 'depot_de_dossier')">
                <i class="fas fa-times"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="column is-4 is-padding-left is-padding-right is-padding-top">
          <r-label :label="'DATE ACCORD BANQUE'" :value="loan.accord_banque" :redCheck="true"></r-label>
          <div class="field has-addons">
            <div class="control">
              <a class="button is-static is-border is-min-width-0 is-square">
                <span class="icon"><i class="fas fa-calendar-alt"></i></span>
              </a>
            </div>
            <div class="control is-expanded has-icons-right">
              <flat-pickr :config="configDate" type="date" @input="commitAdv()"
                class="input is-padding-left-xxsmall is-padding-right-xxsmall"
                v-model="loan.accord_banque"></flat-pickr>
            </div>
            <div class="control">
              <a class="button is-grey is-inverted is-border is-min-width-0 is-square"
                 @click="deleteDate(loan, 'accord_banque')">
                <i class="fas fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns has-bg-grey3 is-multiline is-padding-bottom">
      <div class="column is-gapless is-paddingless is-12 columns is-multiline">
        <div class="column is-4 is-padding-left is-padding-right is-padding-top">
          <r-label :label="'EDITION DE L’OFFRE'" :value="loan.edition_de_l_offre" :redCheck="true"></r-label>
          <div class="field has-addons">
            <div class="control">
              <a class="button is-static is-border is-min-width-0 is-square">
                <span class="icon"><i class="fas fa-calendar-alt"></i></span>
              </a>
            </div>
            <div class="control is-expanded has-icons-right">
              <flat-pickr :config="configDate" type="date" @input="commitAdv()" class="input is-padding-left-xxsmall is-padding-right-xxsmall"
                          v-model="loan.edition_de_l_offre"></flat-pickr>
            </div>
            <div class="control">
              <a class="button is-grey is-inverted is-border is-min-width-0 is-square"
                 @click="deleteDate(loan, 'edition_de_l_offre')">
                <i class="fas fa-times"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="column is-4 is-padding-left is-padding-right is-padding-top">
          <r-label :label="'SIGNATURE DE L’OFFRE'" :value="loan.signature_de_l_offre" :redCheck="true"></r-label>
          <div class="field has-addons">
            <div class="control">
              <a class="button is-static is-border is-min-width-0 is-square">
                <span class="icon"><i class="fas fa-calendar-alt"></i></span>
              </a>
            </div>
            <div class="control is-expanded has-icons-right">
              <flat-pickr :config="configDate" type="date" @input="commitAdv()" class="input is-padding-left-xxsmall is-padding-right-xxsmall"
                          v-model="loan.signature_de_l_offre"></flat-pickr>
            </div>
            <div class="control">
              <a class="button is-grey is-inverted is-border is-min-width-0 is-square"
                 @click="deleteDate(loan, 'signature_de_l_offre')">
                <i class="fas fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline is-border-top has-bg-white is-padding-bottom">
      <div class="column is-gapless is-paddingless is-12 columns is-multiline">
        <div class="column is-4 is-padding-left is-padding-right is-padding-top">
          <r-label :label="'Montant du prêt'" :value="loan_value" :redCheck='true'></r-label>
          <div class="field has-addons">
            <div class="control">
              <a class="button is-static is-border is-min-width-0 is-square">
                <span class="icon"><i :class="`fas fa-${$faCurrency}-sign`"></i></span>
              </a>
            </div>
            <div class="control is-expanded">
              <v-input id="loan_value" name="loan_value" @input="val => updateLoanValue(val)" :model="loan_value"
                       class=""
                       v-validate="'decimal:2'" :errors-bag="errors" data-vv-value-path="val" :number='true'
                       input-type="number"
                       data-vv-as="Montant du prêt">
              </v-input>
            </div>
          </div>
        </div>
        <div class="column is-4 is-padding-left is-padding-right is-padding-top">
          <r-label :label="'Montant de l’apport'" :value="loan_apport" :redCheck='true'></r-label>
          <div class="field has-addons">
            <div class="control">
              <a class="button is-static is-border is-min-width-0 is-square">
                <span class="icon"><i :class="`fas fa-${$faCurrency}-sign`"></i></span>
              </a>
            </div>
            <div class="control is-expanded">
              <v-input id="loan_apport" name="loan_apport" @input="val => updateLoanApport(val)" :model="loan_apport"
                       class=""
                       v-validate="'decimal:2'" :errors-bag="errors" data-vv-value-path="val" :number='true'
                       input-type="number"
                       data-vv-as="Montant de l’apport">
              </v-input>
            </div>
          </div>
        </div>
        <div class="column is-4 is-padding-left is-padding-right is-padding-top">
          <div class="is-margin-bottom-xsmall">
            <r-label :label="'type de prêt'" :redCheck='true' :value="loan.loan_type"></r-label>
          </div>
          <div class="control">
            <div class="select is-fullwidth">
              <select class="" v-model="loan.loan_type" @input="commitAdv()">
                <option :value="null">Sélectionner</option>
                <option value="in_fine">In Fine</option>
                <option value="amortissement">Amortissement</option>
                <!-- <option v-for="a in advDestinationsList" :key="a.value" :value="a.value">{{a.label}}</option> -->
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  import { bus, EVENTS } from '@/services/bus/index.js'

  export default {
    name: 'LoanItem',
    data () {
      return {
        isLoadingReminders: false,
        reminder: null,
        uploading: false,
        configDate: {
          altFormat: 'j/m/Y',
          altInput: true,
          dateFormat: 'Z'
        },
        loan_apport: null,
        loan_value: null
      }
    },
    props: {
      source: {
        type: Object
      },
      multipleLoan: Boolean,
      index: Number
    },
    computed: {
      ...mapGetters(['isAdmin', 'currentUserPk', 'isSectorManager']),
      loan () {
        return this.source
      },
      advPk () {
        return this.$route.params.id
      },
      isEmpty () {
        return (this.loan.bank_name === null || this.loan.bank_name === '') &&
          (this.loan.depot_de_dossier === null || this.loan.depot_de_dossier === '') &&
          (this.loan.accord_banque === null || this.loan.accord_banque === '') &&
          (this.loan.edition_de_l_offre === null || this.loan.edition_de_l_offre === '') &&
          (this.loan.signature_de_l_offre === null || this.loan.signature_de_l_offre === '') &&
          (this.loan.loan_value === null || this.loan.loan_value === '') &&
          (this.loan.loan_apport === null || this.loan.loan_apport === '') &&
          (this.loan.loan_type === null || this.loan.loan_type === '') &&
          (!this.loan.document || this.loan.document.cloudinary_id === null || this.loan.document.path === null)
      }
    },
    filters: {
      dateReminder: function (value) {
        let date = moment(value).format('DD/MM')
        let hour = moment(value).format('HH')
        let minute = moment(value).format('mm')

        return date + ' à ' + hour + 'h' + minute
      }
    },
    methods: {
      openReminder () {
        let params = {
          defaultTitle: this.reminder.title,
          date: moment(this.reminder.date).format('DD/MM/YYYY HH:mm'),
          pk: this.reminder.pk,
          source: this.reminder
        }
        this.$store.commit('setQuickview', {mode: 'EDIT_REMINDER', params})
      },
      loadReminders () {
        this.reminder = null
        this.isLoadingReminders = true
        let params = {}
        if (this.loan.depot_de_dossier) {
          params = {
            custom_fields__code: 'financialAgreementRequiredAutoReminder',
            custom_fields__adv: this.advPk,
            custom_fields__loan: this.index
          }
        } else {
          params = {
            custom_fields__code: 'financialInfoRequiredAutoReminder',
            custom_fields__adv: this.advPk,
            custom_fields__loan: this.index
          }
        }
        this.$api.reminderService.get(params).then(r => {
          if (r.data.items) {
            this.reminder = r.data.items[0]
            // let reminder = {}
            // reminders.forEach(element => {
            //   console.log(element.custom_fields.loan)
            //   console.log(this.index)
            //   if (element.custom_fields.loan === this.index) reminder = element
            // })
            // console.log(reminder)
            // console.log(this.reminder)
            this.isLoadingReminders = false
          }
        })
      },
      update (val) {
        this.loan.bank_name = val
        this.commitAdv()
      },
      download () {
        let link = document.createElement('a')
        link.href = this.loan.document.path
        link.target = '_blank'
        link.click()
      },
      unlink () {
        let empty = {
          account: null,
          cloudinary_id: null,
          cloudinary_version: null,
          filename: null,
          fus_id: null,
          id: null,
          path: null
        }
        this.$set(this.loan, 'document', empty)
        this.commitAdv()
      },
      updateLoanValue (val) {
        this.loan_value = val
        if (this.loan_value === '') this.loan_value = null
        this.commitAdv()
      },
      updateLoanApport (val) {
        this.loan_apport = val
        if (this.loan_apport === '') this.loan_apport = null
        this.commitAdv()
      },
      deleteDate (val, key) {
        val[key] = null
        this.commitAdv()
      },
      remove () {
        let empty = {
          account: null,
          cloudinary_id: null,
          cloudinary_version: null,
          filename: null,
          fus_id: null,
          id: null,
          path: null
        }
        this.$set(this.loan, 'document', empty)
        this.$emit('removeLoan', this.index)
      },
      commitAdv () {
        this.$set(this.loan, 'loan_value', this.loan_value)
        this.$set(this.loan, 'loan_apport', this.loan_apport)
        this.$emit('commitAdv', this.isEmpty, this.index)
      },
      async processFile (event) {
        let file = event.target.files[0]
        let files = new FormData()
        files.append('file[]', file, file.name)
        this.uploading = true
        let document = null
        try {
          let res = await this.$fus.post({ data: files })
          document = res.data[0]
          document.display = true
          document.fus_id = document.id
          this.uploading = false
        } catch (e) {
          console.log(e)
        } finally {
          this.uploading = false
        }
        if (document) {
          this.$emit('upload', this.loan, document)
          this.uploading = false
        }
      }
    },
    created () {
      this.loadReminders()
      bus.$on(EVENTS.NEW_REMINDER, (reminder) => {
        if (reminder.custom_fields.adv === this.advPk && this.index.toString() === reminder.custom_fields.loan) this.loadReminders()
      })
      bus.$on(EVENTS.UPDATE_REMINDER, (reminder) => {
        if (reminder.custom_fields.adv === this.advPk && this.index.toString() === reminder.custom_fields.loan) this.loadReminders()
      })
      bus.$on(EVENTS.DELETE_REMINDER, (reminder) => {
        if (reminder.custom_fields.adv === this.advPk && this.index.toString() === reminder.custom_fields.loan) this.loadReminders()
      })
      this.loan_apport = this.loan.loan_apport
      this.loan_value = this.loan.loan_value
    },
    destroyed () {
      bus.$off([EVENTS.NEW_REMINDER, EVENTS.UPDATE_REMINDER, EVENTS.DELETE_REMINDER])
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/adv/FeuilleDeRoute/LoanItem.vue